import { createAction, props } from '@ngrx/store';

export const CreateOrchestrationSession = createAction('[Orchestration Assistant] Create Session');

export const CreateOrchestrationSessionSuccess = createAction(
    '[Orchestration Assistant] Create Session Success',
    props<{ session_id: string }>()
);

export const CreateOrchestrationSessionFailure = createAction('[Orchestration Assistant] Create Session Failure', props<{ error: any }>());

export const SendOrchestrationMessage = createAction(
    '[Orchestration Assistant] Send Message',
    props<{ session_id: string; message: string }>()
);

export const SendOrchestrationMessageSuccess = createAction(
    '[Orchestration Assistant] Send Message Success',
    props<{ response: string; session_id: string }>()
);

export const SendOrchestrationMessageFailure = createAction('[Orchestration Assistant] Send Message Failure', props<{ error: any }>());

export const LoadOrchestrationHistory = createAction('[Orchestration Assistant] Load History', props<{ session_id: string }>());

export const LoadOrchestrationHistorySuccess = createAction(
    '[Orchestration Assistant] Load History Success',
    props<{ messages: any[]; session_id: string }>()
);

export const LoadOrchestrationHistoryFailure = createAction('[Orchestration Assistant] Load History Failure', props<{ error: any }>());

export const DeleteOrchestrationSession = createAction('[Orchestration Assistant] Delete Session', props<{ session_id: string }>());

export const DeleteOrchestrationSessionSuccess = createAction('[Orchestration Assistant] Delete Session Success');

export const DeleteOrchestrationSessionFailure = createAction('[Orchestration Assistant] Delete Session Failure', props<{ error: any }>());

export const ClearOrchestrationMessages = createAction('[Orchestration Assistant] Clear Messages');

export const LoadOrchestrationSessions = createAction('[Orchestration Assistant] Load Sessions');

export const LoadOrchestrationSessionsSuccess = createAction(
    '[Orchestration Assistant] Load Sessions Success',
    props<{ sessions: any[] }>()
);

export const LoadOrchestrationSessionsFailure = createAction('[Orchestration Assistant] Load Sessions Failure', props<{ error: any }>());

export const LoadPastSession = createAction('[Orchestration Assistant] Load Past Session', props<{ session_id: string }>());
